import React from "react";
import { useNavigate } from "react-router-dom";
import "./Tours.css";

// Importing images
import Europe from "../../assets/images/tours/europe.webp";
import Bali from "../../assets/images/tours/bali.webp";
import Dubai from "../../assets/images/tours/dubai.webp";
import Ireland from "../../assets/images/tours/ireland.png";
import Vietnam from "../../assets/images/tours/vietnam.webp";
import Kerla from "../../assets/images/tours/kerla.jpg";
import kera1 from "../../assets/images/tours/kerla2.jpg"
import kashmir from "../../assets/images/tours/kashmir.jpg"
import kashmir1 from "../../assets/images/tours/kashmir1.jpg";
import shimla from "../../assets/images/tours/shimla (1).jpg"
import shimla1 from "../../assets/images/tours/shimla (2).jpg";
import andman from "../../assets/images/tours/andman (1).jpg";
import adman1 from "../../assets/images/tours/andman (2).jpg";
import NewYork from "../../assets/images/tours/New York - 2.webp";
import NewYork1 from "../../assets/images/tours/New York - 4.avif";
import Uk from "../../assets/images/tours/Jungfraubahn-Kleine-Scheidegg-neuer-und-alter-Zug.avif";
import UK1 from "../../assets/images/tours/Austria.avif";
import russia from "../../assets/images/tours/St-Basils-Cathedral-Moscow (1).avif";
import russia1 from "../../assets/images/tours/St-Petersburg.avif";
import canada from "../../assets/images/tours/Quebec City.avif";
import europe from "../../assets/images/tours/download (11).jpg";
import europe1 from "../../assets/images/tours/download (12).jpg";
import uk from "../../assets/images/tours/photo-1467269204594-9661b134dd2b.avif";


import canada1 from "../../assets/images/tours/Niagara Falls - Skylon Tower.avif";
const Tours = () => {
  const navigate = useNavigate(); // Hook for navigation

  return (
    <div className="tours">
      {/* Domestic Section */}
      <h1>
        <span>Domestic</span> Holiday Packages
      </h1>
      <p>Indulge in unforgettable adventure with special tour plans</p>
      <div className="tours-carousel">
        <div>
        <div className="flip-container">
  <div className="flip-card">
    <div className="flip-front">
      <img src={kera1} alt="kerla.webp" />
    </div>
    <div className="flip-back">
      <img src={Kerla} alt="kerla.webp" />
    </div>
  </div>
  
</div>
<h4>Kerla</h4>
  <h6>Rs 14,980</h6>
  <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>

        <div>
        <div className="flip-container">
  <div className="flip-card">
    <div className="flip-front">
      <img src={kashmir} alt="kerla.webp" />
    </div>
    <div className="flip-back">
      <img src={kashmir1} alt="kerla.webp" />
    </div>
  </div>
  
</div>
<h4>Kashmir</h4>
  <h6>Rs 14,980</h6>
  <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
        <div className="flip-container">
  <div className="flip-card">
    <div className="flip-front">
      <img src={shimla} alt="kerla.webp" />
    </div>
    <div className="flip-back">
      <img src={shimla1} alt="kerla.webp" />
    </div>
  </div>
  
</div>
<h4>Shimla & Kullu</h4>
  <h6>Rs 14,980</h6>
  <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
        <div className="flip-container">
  <div className="flip-card">
    <div className="flip-front">
      <img src={andman} alt="kerla.webp" />
    </div>
    <div className="flip-back">
      <img src={adman1} alt="kerla.webp" />
    </div>
  </div>
  
</div>
<h4>Andman & Nikobar</h4>
  <h6>Rs 14,980</h6>
  <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
          <img src={Bali} alt="bali.webp" />
          <h4>Bali</h4>
          <h6>Rs 15,980</h6>
          <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
          <img src={Ireland} alt="ireland.png" />
          <h4>Ireland</h4>
          <h6>Rs 17,500</h6>
          <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
          <img src={Vietnam} alt="vietnam.webp" />
          <h4>Vietnam</h4>
          <h6>Rs 33,870</h6>
          <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
          <img src={Europe} alt="europe.webp" />
          <h4>Europe</h4>
          <h6>Rs 84,240</h6>
          <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
      </div>

      {/* International Section */}
      <h1 style={{marginTop:"40px"}}>
        <span>International</span> Holiday Packages
      </h1>
      <p>Indulge in unforgettable adventure with special tour plans</p>
      <div className="tours-carousel">
        <div>
        <div className="flip-container">
  <div className="flip-card">
    <div className="flip-front">
      <img src={NewYork1} alt="kerla.webp" />
    </div>
    <div className="flip-back">
      <img src={NewYork} alt="kerla.webp" />
    </div>
  </div>
  
</div>
<h4>New York</h4>
  <h6>Rs 1,50,000</h6>
  <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>

        <div>
        <div className="flip-container">
  <div className="flip-card">
    <div className="flip-front">
      <img src={Uk} alt="kerla.webp" />
    </div>
    <div className="flip-back">
      <img src={UK1} alt="kerla.webp" />
    </div>
  </div>
  
</div>
<h4>Paris</h4>
  <h6>Rs 1,30,980</h6>
  <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
        <div className="flip-container">
  <div className="flip-card">
    <div className="flip-front">
      <img src={canada} alt="kerla.webp" />
    </div>
    <div className="flip-back">
      <img src={canada1} alt="kerla.webp" />
    </div>
  </div>
  
</div>
<h4>Russsia</h4>
  <h6>Rs 2,40,000</h6>
  <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
        <div className="flip-container">
  <div className="flip-card">
    <div className="flip-front">
      <img src={russia} alt="kerla.webp" />
    </div>
    <div className="flip-back">
      <img src={russia1} alt="kerla.webp" />
    </div>
  </div>
  
</div>
<h4>Canada</h4>
  <h6>Rs 2,30,000</h6>
  <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>



        
        <div>
          <img src={Bali} alt="bali.webp" />
          <h4>Bali</h4>
          <h6>Rs 15,980</h6>
          <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
          <img src={Ireland} alt="ireland.png" />
          <h4>Ireland</h4>
          <h6>Rs 17,500</h6>
          <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
          <img src={Vietnam} alt="vietnam.webp" />
          <h4>Vietnam</h4>
          <h6>Rs 33,870</h6>
          <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
          <img src={Europe} alt="europe.webp" />
          <h4>Europe</h4>
          <h6>Rs 84,240</h6>
          <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
      </div>
      <div className="tours-carousel">
        <div>
        <div className="flip-container">
  <div className="flip-card">
    <div className="flip-front">
      <img src={europe} alt="kerla.webp" />
    </div>
    <div className="flip-back">
      <img src={europe1} alt="kerla.webp" />
    </div>
  </div>
  
</div>
<h4>Europe</h4>
  <h6>Rs 2,30,000</h6>
  <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>

        <div>
        <div className="flip-container">
  <div className="flip-card">
    <div className="flip-front">
      <img src={Uk} alt="kerla.webp" />
    </div>
    <div className="flip-back">
      <img src={UK1} alt="kerla.webp" />
    </div>
  </div>
  
</div>
<h4>UK</h4>
  <h6>Rs 1,10,980</h6>
  <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
        <div className="flip-container">
  <div className="flip-card">
    <div className="flip-front">
      <img src={uk} alt="kerla.webp" />
    </div>
    <div className="flip-back">
      <img src={uk} alt="kerla.webp" />
    </div>
  </div>
  
</div>
<h4>Asia</h4>
  <h6>Rs 2,30,000</h6>
  <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
        <div className="flip-container">
  <div className="flip-card">
    <div className="flip-front">
      <img src={russia} alt="kerla.webp" />
    </div>
    <div className="flip-back">
      <img src={russia1} alt="kerla.webp" />
    </div>
  </div>
  
</div>
<h4>Germany</h4>
  <h6>Rs 2,30,000</h6>
  <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>



        
        <div>
          <img src={Bali} alt="bali.webp" />
          <h4>Bali</h4>
          <h6>Rs 15,980</h6>
          <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
          <img src={Ireland} alt="ireland.png" />
          <h4>Ireland</h4>
          <h6>Rs 17,500</h6>
          <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
          <img src={Vietnam} alt="vietnam.webp" />
          <h4>Vietnam</h4>
          <h6>Rs 33,870</h6>
          <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
        <div>
          <img src={Europe} alt="europe.webp" />
          <h4>Europe</h4>
          <h6>Rs 84,240</h6>
          <button className="book" onClick={() => navigate("/contact-us")}>Book Now</button>
        </div>
      </div>
    </div>
  );
};

export default Tours;
